import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS, CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function UpgradeChart(props) {
  const { upgradeData } = props;
  const [viewData, setViewData] = useState([]);
  useEffect(() => {
    if (upgradeData) {
      if (upgradeData.length === 0) {
        const viewDetail = [];
        const details = {
          country: "Not Data Available",
          value: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const data = upgradeData;
        const viewDetail = [];
        for (let index = 0; index < data.length; index++) {
          if((index + 1) > CHART_MAX_VALUES) {
            break;
          }
          const details = {
            country: data[index].current_plan,
            value: data[index].qty,
          };
          viewDetail.push(details);
        }
        setViewData(viewDetail);
      }
    }
  }, [upgradeData]);

  useLayoutEffect(() => {
    const chart = am4core.create('chartdiv64', am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = viewData

    // chart.data = [{
    //   country: 'Outlet 1',
    //   value: 3025
    // }, {
    //   country: 'Outlet 2',
    //   value: 2882
    // }, {
    //   country: 'Outlet 3',
    //   value: 2622
    // }, {
    //   country: 'Outlet 4',
    //   value: 2500
    // }, {
    //   country: 'Outlet 5',
    //   value: 2400
    // }, {
    //   country: 'Outlet 6',
    //   value: 2367
    // }, {
    //   country: 'Outlet 7',
    //   value: 2234
    // }, {
    //   country: 'Outlet 8',
    //   value: 2156
    // }, {
    //   country: 'Outlet 9',
    //   value: 2000
    // }, {
    //   country: 'Outlet 10',
    //   value: 1943
    // }];


    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = 'country';
    categoryAxis.renderer.minGridDistance = 40;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

     // Modify chart's colors
     chart.colors.list = CHART_COLORS;

    const series = chart.series.push(new am4charts.CurvedColumnSeries());
    series.dataFields.categoryX = 'country';
    series.dataFields.valueY = 'value';
    series.tooltipText = '{valueY.value}';
    series.columns.template.strokeOpacity = 0;
    series.columns.template.tension = 1;

    series.columns.template.fillOpacity = 0.75;

    const hoverState = series.columns.template.states.create('hover');
    hoverState.properties.fillOpacity = 1;
    hoverState.properties.tension = 0.8;

    chart.cursor = new am4charts.XYCursor();

    // Add distinctive colors for each column using adapter
    series.columns.template.adapter.add('fill', (fill, target) => chart.colors.getIndex(target.dataItem.index));

    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarY = new am4core.Scrollbar();


    chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="chartdiv64" style={{ width: '100%', height: '500px', direction: "ltr" }} />;
}
